<template>
  <div class="share-post">
    <div data-cy="share-post-button" class="share-post-button" @click="shareByEmail">
      <a class="edit-post-text">
        {{ $t('post.postShare.share') }}
      </a>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'PostShare',
  components: { },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    shareByEmail() {
      const subject = this.$t('post.postShare.subject', {
        userName: this.user.firstName
      })
      const body = this.$t('post.postShare.body', {
        communityName: this.post.community.name,
        link: `${window.location.origin}/posts/${this.post.id}`,
        userFullName: `${this.user.firstName} ${this.user.lastName}`
      })
      const encodedSubject = encodeURIComponent(subject)
      const encodedBody = encodeURIComponent(body)

      window.location.href = `mailto:?subject=${encodedSubject}&body=${encodedBody}`
    }
  },
  computed: mapState({
    user() {
      return this.$store.getters.user || {}
    }
  })
}
</script>
<style scoped>
.share-post {
  width: 100%;
  height: 100%;
}

.share-post-button {
  padding: 4px 12px;
  width: 100%;
  height: 100%;
}

</style>
